import { render } from "./OverlaySpinner.vue?vue&type=template&id=234340d4&scoped=true&bindings={\"showStatusText\":\"props\",\"statusText\":\"props\"}"
import script from "./OverlaySpinner.vue?vue&type=script&lang=js"
export * from "./OverlaySpinner.vue?vue&type=script&lang=js"

import "./OverlaySpinner.vue?vue&type=style&index=0&id=234340d4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-234340d4"

export default script